"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.function.name.js");

var _vue = _interopRequireDefault(require("vue"));

var _main = _interopRequireDefault(require("./src/main.js"));

var _locale = _interopRequireDefault(require("sk-ui/lib/mixins/locale"));

var _this = void 0;

var promptPws = function promptPws() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var dialog = _this && _this.$dialog || _vue["default"].prototype.$dialog;
  dialog.call(_this, {
    template: function template(h) {
      return h("sk-prompt-pws", {
        "attrs": {
          "execute": options.execute,
          "cb": options.cb,
          "cancel-cb": options.cancelCb,
          "length": options.length
        }
      });
    },
    components: {
      SkPromptPws: _main["default"]
    },
    props: {
      title: _locale["default"].methods.t('sk.confirmPws'),
      width: '300px' // showCustomFooter: false,
      // showFooter: false

    }
  });
};

_main["default"].promptPws = promptPws;

_main["default"].install = function () {
  _vue["default"].prototype.$skpromptPws = promptPws;

  _vue["default"].component(_main["default"].name, _main["default"]);
};

var _default = _main["default"];
exports["default"] = _default;